module.exports = __webpack_public_path__ + "static/media/mum-kids06.343e2720.png";